import React from "react";
import Select from "@components/select";
import { COUNT_OPTIONS } from "../../../../constants/options";
import { useFormikContext } from "formik";
import { useSetDefaultValue } from "@hooks";

const name = "numberOfDependents";

export default function DependentCount() {
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
  useSetDefaultValue(name);

  return (
    <>
      <Select
        isPlaceHolder
        placeholder="Select..."
        title="Number of dependants"
        options={COUNT_OPTIONS(0,6)}
        toolTipText="Only count dependants that live with you"

        name={name}
        value={values[name]}
        onChange={handleChange}
        onBlur={handleBlur}
        errorMessage={touched[name] ? errors[name] : ""}
        />
    </>
  );
}
